"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationLinksTags = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyMenuConfigurationLinksTags = (data, multi_selected_links, set_data, tags_group_key, set_tags_group_key, tags_selected, set_tags_selected, t) => {
    const { fluxTags } = data;
    const tags_visible = Object.keys(fluxTags).length > 0;
    const value_selected_parameter = () => {
        if (multi_selected_links.current.length == 0) {
            return {};
        }
        else {
            if (Object.keys(data.links).length === 0 || !(multi_selected_links.current[0].idLink in data.links)) {
                let val = JSON.parse(JSON.stringify(Object(multi_selected_links.current[0].value)));
                Object.values(tags_selected).map(tag_selected => {
                    if (val[tag_selected] === undefined) {
                        val[tag_selected] = {};
                    }
                    val = val[tag_selected];
                });
                return val;
            }
            let val = JSON.parse(JSON.stringify(Object(data.links[multi_selected_links.current[0].idLink].value)));
            Object.values(tags_selected).map(tag_selected => {
                if (val[tag_selected] === undefined) {
                    val[tag_selected] = { 'display_value': '', tags: {}, value: 0 };
                }
                val = val[tag_selected];
            });
            return val;
        }
    };
    // Si le tags_group_key n'est pas (qu'il soit vide ou différent) dans la liste des keys de fluxTags, alors on met à jour en prenant le premier
    if (!Object.keys(fluxTags).includes(tags_group_key) && Object.keys(fluxTags).length > 0) {
        set_tags_group_key(Object.keys(fluxTags)[0]);
    }
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "tags", title: t('Noeud.tags_node.tags'), disabled: /*node.colorParameter !== 'groupTag'*/ false },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                    t('Tags.GE'),
                    ":")),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => set_tags_group_key(evt.target.value) }, Object.entries(fluxTags).map((tags_group, i) => react_1.default.createElement("option", { key: i, value: tags_group[0], selected: tags_group_key === tags_group[0] }, tags_group[1].group_name))))),
        Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
            if (Object.keys(dataTag.tags).length != 0) {
                return (react_1.default.createElement(react_bootstrap_1.Row, { key: dataTagKey },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                            dataTag.group_name,
                            " :")),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                        react_1.default.createElement(react_bootstrap_1.Form.Select, { name: dataTagKey, value: tags_selected[dataTagKey], onChange: (evt) => {
                                //Modifie les paramètres selectionnés
                                const { name, value } = evt.target;
                                set_tags_selected(prevState => (Object.assign(Object.assign({}, prevState), { [name]: value })));
                            } }, Object.entries(dataTag.tags).map(([tag_key, tag]) => {
                            return (react_1.default.createElement("option", { key: tag.name, value: tag_key }, tag.name));
                        })))));
            }
        }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row, style: { paddingTop: '15px' } },
            react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, responsive: 'sm', size: 'sm', className: 'link_tags_affiliation' },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, t('Tags.Nom')),
                        react_1.default.createElement("th", null, t('Noeud.tags_node.Appartenance')))),
                react_1.default.createElement("tbody", null, tags_visible && tags_group_key != '' && Object.keys(fluxTags).includes(tags_group_key) && multi_selected_links.current.length != 0 ? Object.entries(fluxTags[tags_group_key].tags).map(([tag_key, tag]) => {
                    return (react_1.default.createElement("tr", { key: tag_key },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_bootstrap_1.FormLabel, null, tag.name)),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'element_visible' + tag_key, checked: value_selected_parameter().tags[tags_group_key] === tag_key, id: tag_key, type: 'checkbox', onChange: (evt) => {
                                    const new_nb_element = evt.target;
                                    const new_tag_key = new_nb_element.id;
                                    const visible = new_nb_element.checked;
                                    Object.values(data.links).filter(f => multi_selected_links.current.map(d => d.idLink).includes(f.idLink)).map(d => {
                                        let val = Object(d.value);
                                        Object.values(tags_selected).forEach(tag => {
                                            if (val[tag] === undefined) {
                                                val[tag] = {};
                                            }
                                            val = val[tag];
                                        });
                                        val.tags[tags_group_key] = visible ? new_tag_key : '';
                                    });
                                    set_data(Object.assign({}, data));
                                } }))));
                }) : (react_1.default.createElement(react_1.default.Fragment, null))))));
};
exports.SankeyMenuConfigurationLinksTags = SankeyMenuConfigurationLinksTags;
